module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"FinLexiconGlossar":{"autocomplete_data_not_found":"Leider nicht gefunden","autocomplete_placeholder_label":"Schlagwort oder Fachbegriff"}},"en":{"FinLexiconGlossar":{"autocomplete_data_not_found":"Not found","autocomplete_placeholder_label":"Keyword or technical term"}}}')
  delete Component.options._Ctor
}
